import React from 'react';
import UnimplementedView from "../../modules/UnimplementedView";

function YellowBox(props) {
  return React.createElement(UnimplementedView, props);
}

YellowBox.ignoreWarnings = function () {};

export default YellowBox;